import React from 'react';

const EsperandoFirma = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 20 24'>
      <g fill='none' fillRule='evenodd' transform='translate(-4 -1)'>
        <rect width='24' height='24' />
        <path fill='#FC7B1E' fillRule='nonzero' d='M17,12 C14.24,12 12,14.24 12,17 C12,19.76 14.24,22 17,22 C19.76,22 22,19.76 22,17 C22,14.24 19.76,12 17,12 Z M18.65,19.35 L16.5,17.2 L16.5,14 L17.5,14 L17.5,16.79 L19.35,18.64 L18.65,19.35 Z M18,3 L14.82,3 C14.4,1.84 13.3,1 12,1 C10.7,1 9.6,1.84 9.18,3 L6,3 C4.9,3 4,3.9 4,5 L4,20 C4,21.1 4.9,22 6,22 L12.11,22 C11.52,21.43 11.04,20.75 10.69,20 L6,20 L6,5 L8,5 L8,8 L16,8 L16,5 L18,5 L18,10.08 C18.71,10.18 19.38,10.39 20,10.68 L20,5 C20,3.9 19.1,3 18,3 Z M12,5 C11.45,5 11,4.55 11,4 C11,3.45 11.45,3 12,3 C12.55,3 13,3.45 13,4 C13,4.55 12.55,5 12,5 Z' />
      </g>
    </svg>
  );
};

export default EsperandoFirma;
